/**
 * Welcome Flow
 * 
 * Greets new users when they first arrive at the app.
 * Runs once per user.
 */

import { SquiggleFlow } from '../types';

export const welcomeFlow: SquiggleFlow = {
  id: 'welcome.v1',
  version: 1,
  title: 'Welcome to MyMinu',
  priority: 100,
  enabledByDefault: true,
  
  gating: {
    oncePerUser: true,
  },
  
  triggers: [
    { 
      type: 'route', 
      match: { kind: 'pattern', pattern: '/app*' }, 
      when: 'enter' 
    },
  ],
  
  steps: [
    {
      id: 'arrive',
      action: { 
        kind: 'moveTo', 
        target: { type: 'viewport', x: 0.85, y: 0.75 },
        arrival: { durationMs: 600, trail: 'draw' }
      },
    },
    {
      id: 'set-excited',
      action: { kind: 'setMood', mood: 'excited' },
    },
    {
      id: 'wave',
      action: { kind: 'gesture', name: 'wave' },
    },
    {
      id: 'greet',
      action: {
        kind: 'speak',
        text: "Hi there! I'm Squiggle! 👋 I'll be here to help you manage your child's daily routines.",
        bubble: { 
          placement: 'top', 
          showNext: true,
          showDismiss: true,
          widthPx: 260,
        },
      },
    },
    {
      id: 'explain',
      action: {
        kind: 'speak',
        text: "You can create tasks, set up routines, and I'll help guide your little one through their day!",
        bubble: { 
          placement: 'top', 
          showNext: true,
          showDismiss: true,
        },
      },
    },
    {
      id: 'celebrate',
      action: { kind: 'gesture', name: 'celebrate' },
    },
    {
      id: 'farewell',
      action: {
        kind: 'speak',
        text: "Let's get started! Click the + button to create your first task.",
        bubble: { 
          placement: 'top', 
          showDismiss: true,
        },
      },
    },
    {
      id: 'wait-dismiss',
      action: { 
        kind: 'waitFor', 
        condition: { type: 'ms', durationMs: 4000 } 
      },
      timeoutMs: 10000,
    },
    {
      id: 'settle',
      action: { kind: 'setMood', mood: 'idle' },
    },
  ],
  
  onExit: {
    clearTrail: true,
    mood: 'idle',
    returnHome: true,
  },
};

export default welcomeFlow;
